/**
 * @param marker {PropertyMarker}
 * @returns {string}
 */


export function myPropertyMarkerTemplateIcon(marker) {
    return `
            <div class="my-property-marker-icon">
                <i class="fa-property-maker-icon fas fa-map-marker-alt"></i>
            </div>
        `;
}
